// Runs a function if it is a function, otherwise returns the function as a value
export const runIfFn = (fn: any, ...args: any[]) => {
	if (typeof fn === 'function') {
		return fn(...args);
	}

	return fn;
};
